import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import InformationSection from '../../../../components/InformationSection';

class TotalPlayers extends PureComponent {
	render() {
		const { userCount, inTheRunningCount, locale } = this.props;

		return (
			<InformationSection>
				<InformationSection.Label>{locale['total.players']}</InformationSection.Label>
				<InformationSection.Value>{userCount}</InformationSection.Value>
			</InformationSection>
		);
	}
}

TotalPlayers.propTypes = {
	userCount: PropTypes.number.isRequired,
	locale: PropTypes.objectOf(PropTypes.string),
	inTheRunningCount: PropTypes.number, // In the running count was disabled in favour of always showing the total
};

TotalPlayers.defaultProps = {};

export default TotalPlayers;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/totalPlayers/TotalPlayers.component.js